/**
 * Round a number to the nearest X decimal places
 *
 * @param num The number to round
 * @param scale The precision at which to round to
 * @returns The number rounded to the correct number of decimal places
 */
export const roundNumber = (num: number, scale: number = 2): number => {
  let result = num;
  if (isNaN(result)) {
    result = 0;
  } else {
    const accuracy = Math.pow(10, scale);
    result = Math.round((result + Number.EPSILON) * accuracy) / accuracy;
  }

  return result;
};
